import React from "react";
import "./singlePost.css";

export default function SinglePost() {
    return (
        <div className="single__post">
            <div className="img">
                <img src="https://source.unsplash.com/800x580/?blog,water" alt="" />
            </div>
            <h3 className="title">블로그 제목입니다.</h3>
            <div className="info">
                <span class="author">
                    <a href="/">황상연</a>
                </span>
                <span class="date">2022-04-03</span>
                <span class="modify">
                    <a href="/">수정</a>
                </span>
                <span class="delete">
                    <a href="/">삭제</a>
                </span>
            </div>
            <div className="desc">
                <p>
                    연합뉴스에 따르면 김부겸 국무총리는 오는 29일 코로나19 중앙재난안전대책본부(중대본) 회의에서 이 같은
                    방침을 발표할 계획이다. 야외 마스크 착용 의무 해제가 발표될 경우 5월 2일부터 적용될 전망이다. 방역
                    당국과 대통령직인수위원회는 실외 마스크 착용 의무화 해제 시점을 두고 미묘한 입장차를 나타냈었다.
                    손영래 중앙사고수습본부 사회전략반장은 지난 27일 브리핑에서 “29일 중대본에서 실외 마스크 착용 해제
                    여부를 결정해 발표할 것”이라고 밝혔다. 방역 당국은 코로나19 상황이 개선되고 있는 상황에서 야외
                    마스크를 해제해도 전파 위험은 현저히 낮을 것으로 보고 있다. 하지만 안철수 대통령직인수회 위원장은
                    전날 새정부 출범 30일 이내에 ‘실외마스크 프리’ 선언을 검토하겠다고 밝혔다. 해제 선언 시점으로는 ‘5월
                    하순 정도에 상황을 보고 판단하겠다’고 했다. 안 위원장의 발언은 현 정부의 실외 마스크 착용 해제
                    결정을 보류해야 한다는 뜻으로 해석됐다. 방역 당국도 29일 야외 마스크 의무 해제 여부를 발표하는
                    방안과 새 정부에 결정을 넘기는 방안을 모두 검토해온 것으로 전해졌다. 정부는 그러나 현재 마스크를
                    벗지 않을 근거나 명분이 없다는 결론을 최종적으로 내린 것으로 알려졌다. 코로나 확산이 안정세를 보이고
                    있고 감염병 등급 하향 조정도 이뤄진 상황에서 야외 마스크 해제를 하지 않을 이유가 없다는 것이다.
                    의무화 해제가 이미 예고된 상황에서 다음 정부로 결정을 미루는 것이 오히려 ‘정치 방역’으로 비칠 수
                    있다는 우려도 제기된 것으로 알려졌다. 야외 마스크 의무가 해제될 경우 실내 마스크 착용 의무를 제외한
                    일상 생활의 제약이 대부분 사라지게 된다.
                </p>
                <p>
                    국민의힘 하태경 의원은 28일 국회에서 기자회견을 열고 이같이 밝혔다. 하 의원이 여가부로부터 제출받은
                    자료에 따르면 여가부 직원 A씨는 B씨를 강제로 포옹하고 성적 불쾌감을 주는 성희롱을 한 것으로
                    조사됐다. 여가부는 가해자 A씨에게 경징계인 ‘견책’(시말서 제출) 처분을 했고 징계 10일 뒤 피해자 B씨는
                    개인 사유로 퇴사했다. A씨는 사건 후 성폭력 방지 부서에 배치됐다가 부서를 옮긴 뒤 올해 승진한 것으로
                    전해졌다. 하 의원은 피해자가 특정될 우려가 있다며 사건 발생 일시, 장소 등은 공개하지 않았다.
                    여가부는 다만 ‘가해자의 승진과 피해자의 퇴사 모두 사건과 무관하다’고 해명한 것으로 전해졌다. 당시
                    여가부는 자체적으로 피해자 문답 조사, 참고인 조사 등을 진행했고 고충심의위 외부위원 등의 전문가
                    자문을 거쳐 경징계를 결정했다.
                </p>
            </div>
        </div>
    );
}
